import React, { useState } from 'react';
import axios from 'axios';
import './attendacedashboard.css';

const AttendanceDashboard: React.FC = () => {
  const [date, setDate] = useState('');
  const [attendanceData, setAttendanceData] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const fetchAttendanceData = async (selectedDate: string) => {
    try {
      setLoading(true);
      setError('');
      const response = await axios.get(
        `/Branches/attendance/?date=${selectedDate}`
      );
      setAttendanceData(response.data);
    } catch (err: any) {
      console.error('Error fetching attendance data:', err);
      setError('Failed to fetch attendance data. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setDate(e.target.value);
    if (e.target.value) {
      fetchAttendanceData(e.target.value);
    }
  };

  return (
    <div className="attendance-summary-container">
      <h2 className="header">Attendance Dashboard</h2>
      <div className="form-group">
        <label htmlFor="date" className="form-label">Select Date</label>
        <input
          type="date"
          id="date"
          value={date}
          onChange={handleDateChange}
          className="form-control"
        />
      </div>

      {loading && <p className="loading-text">Loading attendance data...</p>}
      {error && <p className="error-text">{error}</p>}

      {attendanceData && (
        <>
          <div className="summary">
            <div className="card enhanced-card primary-card">
              <div className="card-body">
                <h5 className="card-title">Total Present</h5>
                <h1 className="card-text">{attendanceData.school_summary.total_present}</h1>
              </div>
            </div>
            <div className="card enhanced-card danger-card">
              <div className="card-body">
                <h5 className="card-title">Total Absent</h5>
                <h1 className="card-text">{attendanceData.school_summary.total_absent}</h1>
              </div>
            </div>
            <div className="card enhanced-card info-card">
              <div className="card-body">
                <h5 className="card-title">Total Students in School</h5>
                <h1 className="card-text">{attendanceData.school_summary.total_students_in_school}</h1>
              </div>
            </div>
          </div>

          {/* Table for Absent Students */}
          <h3>Absent Students</h3>
          <table className="absent-students-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Class</th>
                <th>Stream</th>
              </tr>
            </thead>
            <tbody>
            {attendanceData.absent_students.map((student: any, index: number) => (
              <tr key={index}>
                <td>{student.name}</td>
                <td>{student.class}</td>
                <td>{student.section}</td>
              </tr>
            ))}
          </tbody>

          </table>

          <div className="attendance-details">
            <h3>Class Attendance</h3>
            <div className="details-grid">
              {attendanceData.class_attendance.map((cls: any, index: number) => (
                <div key={index} className="card enhanced-card">
                  <div className="card-body">
                    <h5 className="card-title">{cls.class_associated__name}</h5>
                    <p className="card-text">Present: {cls.present}</p>
                    <p className="card-text">Absent: {cls.absent}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default AttendanceDashboard;